import { Component, OnInit, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-day-report',
  templateUrl: './day-report.component.html',
  styleUrls: ['./day-report.component.scss']
})
export class DayReportComponent {
  @Input() report_data: any;

  visibleloader: boolean = true;
  ngOnInit(): void {
    this.visibleloader = false;
  }
  formatNumber(stringValue) {
    if (stringValue != null) {
        if (typeof stringValue === 'string') {
          const numericValue = parseFloat(stringValue.replace(/,/g, '')); // Remove commas and convert to a number
          // Use DecimalPipe to format the numericValue
          const formattedValue = new DecimalPipe('en-US').transform(numericValue, '1.2-2');
          return formattedValue;
        } else {
          return stringValue.toFixed(2);
        }
    } else {
      return 0;
    }
  }
}
